export default __webpack_public_path__ + "media/Jira_right.7ebfa6270b9000e76c3bddd887986bbc.svg";